(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jib-drinkware-campaign"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jib-drinkware-campaign')) {
  customElements.define('jib-drinkware-campaign', class extends HTMLElement {
    connectedCallback() {
      const checkExpiry = () => {
        const remaining = Number(this.dataset.end) - Date.now();
        if (remaining <= 0) this.hidden = true;
        else this.expiryTimer = setTimeout(checkExpiry, Math.min(remaining, 2147483647));
      };
      checkExpiry();
    }
    disconnectedCallback() { clearTimeout(this.expiryTimer); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
